import React from 'react';

import { ReactComponent as FPSIcon } from '@/assets/icons/fps-big.svg';
import MainLayout, { MainLayoutProps } from '@/layout/MainLayout';

export type FPSLayoutProps = MainLayoutProps;

export const FPSLayout: React.FC<FPSLayoutProps> = ({ header, ...props }: FPSLayoutProps) => (
  <MainLayout {...props} header={{ ...header, titlePostfix: <FPSIcon /> }} />
);
export default FPSLayout;
